import { GameScene } from '@Core/GameScene/GameScene';
import { GameComponent } from '@Core/GameComponent/GameComponent';
import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameStates } from '@Managers/StateManager/GameStates';
import { EGameEvents } from '@Managers/Events/GameEvents';
import { DynamicCasinoJackpotLevels } from './DynamicCasinoJackpotLevels';
import { IDynamicCasinoJackpotConfig } from '@GFTypes/index';

export class DynamicCasinoJackpot extends GameComponent {
    public scene: GameScene;
    private configuration: IDynamicCasinoJackpotConfig;
    public dynamicCasinoJackpotLevels: DynamicCasinoJackpotLevels;

    constructor(scene: GameScene, config: IDynamicCasinoJackpotConfig) {
        super(scene);
        this.scene = scene;
        Logger.log(LoggerLevel.Constructor, {
            source: LoggerSource.Game,
            message: 'Dynamic Casino Jackpot Feature constructor'
        });
        this.configuration = config;
        this.featruesInitialization();
    }

    private featruesInitialization() {
        this.dynamicCasinoJackpotLevels = new DynamicCasinoJackpotLevels(this.scene, this.configuration);
    }
}
